import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { AttachmentsService } from '../services/attachments/attachments.service';


@Component({
  selector: 'app-modal-content',
  templateUrl: './modal-content.component.html',
  styleUrls: ['./modal-content.component.css']
})
export class ModalContentComponent implements OnInit {
  title: string;
  closeBtnName: string;
  message: string;
  onClose: OnCloseModel;

  constructor(public bsModalRef: NgbActiveModal, private _attachmentService: AttachmentsService) { }

  ngOnInit() {
    this.message = this._attachmentService.getMessage();
    this.title = this._attachmentService.getTitle();
  }

  close() {
    this.bsModalRef.close();
  }

  ngOnDestroy() {
    if (this.onClose) {
      this.onClose(true);
    }
  }
}

export type OnCloseModel = (output: boolean) => void;
